const reducer = (state: any) => {
  return {
    ...state,
    waiting: false,
    giftCardToRemove: null,
  };
};

export default reducer;
